import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
} from "reactstrap";
import styled from "styled-components";

const StyledDropdown = styled(Dropdown)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledToggle = styled(DropdownToggle)`
  width: 100%;
  justify-content: space-between;
  text-align: left;
`;

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);

  width: 98%;
  max-height: 260px;
  overflow-y: auto;

  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);

  z-index: 1050;
`;

const StyledItem = styled.div`
  display: flex;
  align-items: center;

  padding: 8px 16px;
  cursor: pointer;
  user-select: none;

  background-color: ${({ $selected }) => ($selected ? "#232323" : "transparent")};

  color: ${({ $selected }) => ($selected ? "#e9ecef" : "#232323")};

  &:hover {
    background-color: ${({ $selected }) => ($selected ? "#2f2f2f" : "#f1f1f1")};
  }
`;

const formatSelectedItems = (
  options,
  selectedIds,
  placeholder,
  maxVisible = 2
) => {
  if (!selectedIds.length) return placeholder;

  const selectedNames = options
    .filter(opt => selectedIds.includes(opt.id))
    .map(opt => opt.name);

  return selectedNames.join(", ");
};

export const MultiSelect = ({
  options = [],
  value = [],
  onChange,
  showSelectAll = true,
  placeholder = "Selecionar",
}) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(prev => !prev);

  const allSelected = value.length === options.length && options.length > 0;

  const toggleItem = (id) => {
    if (value.includes(id)) {
      onChange(value.filter(v => v !== id));
    } else {
      onChange([...value, id]);
    }
  };

  const toggleAll = () => {
    if (allSelected) {
      onChange([]);
    } else {
      onChange(options.map(o => o.id));
    }
  };

  const label = formatSelectedItems(options, value, placeholder);

  return (
    <DropdownWrapper>
      <StyledDropdown isOpen={open} toggle={toggle}>
        <StyledToggle caret color="light">
          <span style={{ color: value.length ? "inherit" : "#6c757d" }}>
            {label}
          </span>
        </StyledToggle>

        {open && (
          <StyledMenu>
            {showSelectAll && (
              <StyledItem
                onClick={toggleAll}
                $selected={allSelected}
              >
                <strong>Selecionar todos</strong>
              </StyledItem>
            )}

            {options.map(opt => (
              <StyledItem
                key={opt.id}
                onClick={() => toggleItem(opt.id)}
                $selected={value.includes(opt.id)}
              >
                {opt.name}
              </StyledItem>
            ))}
          </StyledMenu>
        )}
      </StyledDropdown>
    </DropdownWrapper>
  );
};
